import Constants from '../../settings';

/**
 * The "g then a letter" chords that go to a page - Gmail's and GitHub's
 * convention. A chord rather than ctrl with a digit, which is tab switching
 * in every browser, and a bare letter is left alone while typing anyway.
 *
 * The letters are fixed here per page name, and a page that is not in the
 * routes (a service switched off at build time) simply has no chord.
 */

export interface NavigationChord {
  key: string;
  path: string;
  description: string;
}

interface RouteLike {
  name: string;
  path: string;
  link?: string;
}

const letters: { [routeName: string]: string } = {
  Library: 'l',
  YouTube: 'y',
  SoundCloud: 'c',
  Mixcloud: 'm',
  Spotify: 's',
  OneDrive: 'o',
  'Google Drive': 'g',
  Dropbox: 'd',
  Podcasts: 'p',
  Settings: ',',
};

export const chordPrefix = 'g';

export function chordsFor(routes: readonly RouteLike[]): NavigationChord[] {
  const chords: NavigationChord[] = [];

  for (const route of routes) {
    const key = letters[route.name];

    if (key === undefined) {
      continue;
    }

    chords.push({
      key,
      path: route.link || route.path,
      description: `Go to ${route.name}`,
    });

    // The queue view is the library page with a playlist chosen, so it
    // sits right after Library.
    if (route.name === 'Library') {
      chords.push({
        key: 'n',
        path: `${route.link || route.path}/${Constants.ActivePlaylistId}`,
        description: `Go to ${Constants.ActivePlaylistName}`,
      });
    }
  }

  return chords;
}
